/**
 * Tiny markdown <-> HTML utilities for the Content Studio editor.
 *
 * We use `marked` for md -> html (fast, GFM-ish defaults) and `turndown`
 * for html -> md. Headings use ATX (`#`, `##`) and lists use `-` so we
 * keep round-trips stable with the rest of the codebase (gap analysis,
 * autogen section detection, etc.).
 */
import { marked } from "marked";
import TurndownService from "turndown";

marked.setOptions({ gfm: true, breaks: false });

const turndown = new TurndownService({
  headingStyle: "atx",
  bulletListMarker: "-",
  codeBlockStyle: "fenced",
  emDelimiter: "_",
});

// Preserve hard line breaks inside paragraphs as proper markdown soft breaks
// instead of dropping them.
turndown.addRule("preserveBreaks", {
  filter: "br",
  replacement: () => "  \n",
});

export function mdToHtml(md) {
  if (!md) return "";
  return marked.parse(md);
}

export function htmlToMd(html) {
  if (!html) return "";
  return turndown.turndown(html).trim();
}
